export default "__VITE_ASSET__TwRQ1EO1__"